import './Header.css';
import barnyardBg from '../../assets/backgrounds/barnyard-bg.webp';
import nastyBg from '../../assets/backgrounds/nasty-bg.png';
import aideraBg from '../../assets/backgrounds/aidera-bg.jpeg';
import worksmithBg from '../../assets/backgrounds/worksmith.jpeg';
import omniaBg from '../../assets/backgrounds/omnia.jpeg';
import React, { useState, useEffect, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import Pagination from './Pagination';
import { useSwipeable } from 'react-swipeable';

function Header() {

  const bgList = useMemo(() => [
    {
      id: 0,
      name: 'The Barnyard',
      location: 'UAE, Lebanon',
      industry: 'Food & Beverage',
      src: barnyardBg
    },
    {
      id: 1,
      name: 'Nasty Cookie',
      location: 'Singapore',
      industry: 'Food & Beverage',
      src: nastyBg
    },
    {
      id: 2,
      name: 'Aidera',
      location: 'Ireland',
      industry: 'Technology',
      src: aideraBg
    },
    {
      id: 3,
      name: 'Worksmith',
      location: 'Lebanon',
      industry: 'Real Estate',
      src: worksmithBg
    },
    {
      id: 4,
      name: 'Omnia Health Sciences',
      location: 'Switzerland ',
      industry: 'Healthcare & Biotech',
      src: omniaBg
    }
  ], [])

  const [currentBg, setCurrentBg] = useState(bgList[0]);

  const handlers = useSwipeable({
      onSwiped: (eventData) => {
          if (eventData.dir === 'Left') {
              setCurrentBg(bgList[(currentBg.id + 1) % bgList.length]);
          } else if (eventData.dir === 'Right') {
              setCurrentBg(bgList[(currentBg.id - 1 + bgList.length) % bgList.length]);
          }
      }
  });

  useEffect(() => {
    const intervalID = setInterval(() =>  {
      setCurrentBg(bgList[(currentBg.id + 1) % bgList.length]);
    }, 3000);

    return () => clearInterval(intervalID);
}, [currentBg, bgList]);

  return (
    <header {...handlers} style={{ touchAction: 'pan-y' }}>
        <div className="motto">
            <p><b>Investing</b> in Brands and <b>Solidifying</b> Brand Expansions</p>
        </div>
        <button><a href="#about">Explore More</a></button>
        {
          currentBg.src.includes('.mp4') ? (
            <video src={currentBg.src} autoPlay muted loop className="bg-red-200" />
          ) : (
            <img src={currentBg.src} alt={currentBg.name.toLowerCase()} />
          )
        }
        <span className="bg-name">{currentBg.name}</span>
        <span className="bg-location"><FontAwesomeIcon className="bg-location-icon" icon={faLocationDot} /> {currentBg.location}</span>
        <span className="bg-industry">{currentBg.industry}</span>
        <Pagination totalHeaders={bgList.length} currentHeader={currentBg} setCurrentHeader={setCurrentBg} headers={bgList} />
    </header>
  );
}

export default Header;